import { UseQueryOptions, useQuery, useQueries, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { CollectionView } from 'common';
import { getCollection } from './api';

export const useQueryCollection = (
  id: string,
  includeQuery: boolean = false,
  token?: string,
  config?: Omit<UseQueryOptions<CollectionView | undefined>, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    queryKey: QUERY_KEYS.collection(id, { includeQuery, token }),
    queryFn: () => getCollection(id, includeQuery, token),
    ...config,
  });

/**
 * Load a dynamic list of collection
 */
export const useQueriesCollection = (
  collectionIds: string[],
  includeQuery: boolean = false,
  token?: string
): UseQueryResult<CollectionView>[] => {
  const queries = collectionIds.map((id) => ({
    queryKey: QUERY_KEYS.collection(id, { includeQuery, token }),
    queryFn: () => getCollection(id, includeQuery, token),
  }));
  // Cast to change generic type because of bad types of useQueries
  // see: https://github.com/tannerlinsley/react-query/issues/1675
  return useQueries({ queries }) as UseQueryResult<CollectionView>[];
};
